import Mailing from './Mailing';
export default Mailing;
